import SuiBox from "components/SuiBox";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ClassDetails from "../components/class-details";

const NewClass = ({ redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/class/new") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <ClassDetails />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};
NewClass.defaultProps = {
  redirectTo: "",
};

NewClass.propTypes = {
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state) => ({
  redirectTo: state.ui.redirectTo,
});

export default connect(mapStateToProps, null)(NewClass);
